import { use } from 'react'

import { Text } from '@chakra-ui/react'

import { ButtonDownloadFromFile } from '@/views/components/ButtonDownloadFromFile/ButtonDownloadFromFile'
import { InterviewDataContext } from '@/views/screens/Interview/context'

import { useAudioRecorder } from '../../../context/AudioRecorderContext/AudioRecorderContext'

export const ProcessedToolbox = () => {
  const { file, isReadOnly } = use(InterviewDataContext)

  const { recordedFile } = useAudioRecorder()

  return (
    <>
      {file && (
        <>
          {recordedFile ? (
            <ButtonDownloadFromFile
              file={recordedFile}
              isDisabled={isReadOnly}
              text={'Download recorded meeting'}
            />
          ) : (
            <Text fontWeight={'bold'} fontSize={'1.25rem'}>
              {file.name}
            </Text>
          )}
        </>
      )}
    </>
  )
}
